export default "__VITE_ASSET__gH4nXqzb__"